import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection, SectionGroup } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { ConditionOfSampleTested } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import WholePortionAnnexAPreparationSection from './WholePortionAnnexAPreparationSection';
import WholePortionAnnexBPreparationSection from './WholePortionAnnexBPreparationSection';
import WholePortionStandardOvenDryPreparationSection from './WholePortionStandardOvenDryPreparationSection';
import WholePortionStandardPreDriedPreparationSection from './WholePortionStandardPreDriedPreparationSection';

let WholePortionPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const conditionOfSampleTested = useSelector(
    pipe(createWorksheetSelector!('Preparation.ConditionOfSampleTested'))
  ) as ConditionOfSampleTested;

  return (
    <PageSection heading="Sieve Portion Preparation">
      <SectionGroup heading="Material Mass">
        {conditionOfSampleTested === ConditionOfSampleTested.PreDried && (
          <WholePortionStandardPreDriedPreparationSection />
        )}
        {conditionOfSampleTested === ConditionOfSampleTested.OvenDry && (
          <NamePrefixModifier appendNamePrefix="Masses.MassMeasurement.MeasuredConstantDryMass">
            <WholePortionStandardOvenDryPreparationSection />
          </NamePrefixModifier>
        )}
        {conditionOfSampleTested === ConditionOfSampleTested.WashedWetThenOvenDried && (
          <WholePortionAnnexBPreparationSection />
        )}

        {(conditionOfSampleTested === ConditionOfSampleTested.AsReceived ||
          conditionOfSampleTested === ConditionOfSampleTested.AirDried) && <WholePortionAnnexAPreparationSection />}
      </SectionGroup>
    </PageSection>
  );
};
WholePortionPreparationSection = withInjectedProps(WholePortionPreparationSection);

export { WholePortionPreparationSection };
export default WholePortionPreparationSection;
